import { cva } from 'class-variance-authority';
import styles from '../styles.module.scss';

export const headCellVariants = cva(styles.headCell, {
  variants: {
    align: {
      left: styles.alignLeft,
      right: styles.alignRight,
    },
  },
  defaultVariants: {
    align: 'left',
  },
});
